import { api } from "./api";
import type {
  MessageApiResponse,
  MessagePayload,
  SentMessageApiResponse,
} from "./message-service/types";

const service = "bff-message-service";
// const mockMessages = [
//   {
//     id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//     message:
//       "Small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful",
//     entityId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//     entityType: "PORT_SERVICES",
//     authorName: "Marine Operator",
//     authorId: "marine-operator-dev@endava.com",
//     creationDateTime: "2025-12-09T15:57:27.526Z",
//   },
//   {
//     id: "3fa85f64-5717-4562-b3fc-2c963f66afa7",
//     message:
//       "Small river named Duden flows by their place and supplies it with the necessary regelialia.",
//     entityId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//     entityType: "PORT_SERVICES",
//     authorName: "Shipping Agent",
//     authorId: "shipping-agent-dev@endava.com",
//     creationDateTime: "2025-12-09T15:57:27.526Z",
//   },
//   {
//     id: "3fa85f64-5717-4562-b3fc-2c963f66afa7",
//     fileName: "Certificate.pdf",
//     entityId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//     entityType: "PORT_SERVICES",
//     authorName: "Marine Operator",
//     authorId: "marine-operator-dev@endava.com",
//     message: "",
//     creationDateTime: "2025-12-09T15:57:27.526Z",
//   },
// ];

export const getMessages = async ({
  entityId,
  entityType,
  threadKey,
}: {
  entityId: string;
  entityType: string;
  threadKey?: string;
}) => {
  const threadParam = threadKey ? `&thread_key=${encodeURIComponent(threadKey)}` : "";
  const data: MessageApiResponse[] = await api.get(
    service,
    `message?entity_id=${entityId}&entity_type=${entityType}${threadParam}`,
  );

  return data;
};

export const sendMessage = async ({
  payload,
  transactionId,
}: {
  payload: MessagePayload;
  transactionId?: string;
}) => {
  return api.post<SentMessageApiResponse>(
    service,
    "message",
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};
